// Money helpers. Prices are dollars as JS numbers; every intermediate is
// snapped to 1e-6 first so float noise (15 * 0.67 = 10.050000000000001)
// can't push a value across a rounding boundary.

const snap = (x) => Math.round(x * 1e6) / 1e6;

/** Excel ROUNDUP(x, 0) for non-negative x. */
export const roundUpDollar = (x) => Math.ceil(snap(x));

/** Round to cents (half away from zero). */
export const cents = (x) => Math.round(snap(x) * 100) / 100;

export const formatUSD = (x) =>
  x == null
    ? "TBD"
    : x.toLocaleString("en-US", { style: "currency", currency: "USD" });
